import React, {useState} from 'react';
import {DateRangePicker as DefaultPicker} from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {useTranslation} from 'react-i18next';
import '../../assets/css/datepicker.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {COLORS} from '../../constants';
import PropTypes from 'prop-types';
import moment from 'moment';

const DateRangePicker = ({onDatesChange, ...props}) => {
  const [focusedPicker, setFocusedPicker] = useState(null);
  const {t} = useTranslation('common');

  const customOnDatesChange = ({startDate, endDate, ...others}) => {
    return onDatesChange({
      startDate: startDate ? moment(startDate).startOf('day').utcOffset(0, true) : null,
      endDate: endDate ? moment(endDate).endOf('day').utcOffset(0, true) : null,
      ...others,
    });
  };

  return (
    <DefaultPicker
      minimumNights={0}
      startDatePlaceholderText={t('datepicker.start')}
      endDatePlaceholderText={t('datepicker.end')}
      startDateId="range_start"
      endDateId="range_end"
      onFocusChange={focusedInput => setFocusedPicker(focusedInput)}
      focusedInput={focusedPicker}
      customCloseIcon={<FontAwesomeIcon icon={faTimes} color={COLORS.BLACK}/>}
      showClearDates
      onDatesChange={customOnDatesChange}
      {...props}/>
  );
};


DateRangePicker.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  isOutsideRange: PropTypes.func,
  onDatesChange: PropTypes.func,
};

DateRangePicker.defaultProps = {
  isOutsideRange: () => false,
};

export default DateRangePicker;
